import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const el = document.getElementById('first-cta');
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, []);
  return <AnimatePresence data-id="element-33" data-mp="2aus3qkp8zhxm">
      {visible && <motion.div initial={{
      y: 110,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 110,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="pointer-events-none fixed inset-x-0 bottom-0 z-40 px-3 pb-3 sm:bottom-3" data-id="element-34" data-mp="38ayvoeym47gm">
          <div className="pointer-events-auto mx-auto max-w-md" data-id="element-35" data-mp="333ay56gzyuof">
            <a href={CHECKOUT_URL} className="animate-cta-shake flex items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-3.5 text-navy-950 shadow-[0_5px_0_0_#B38900,0_12px_30px_rgba(6,18,41,0.45)] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand/70" data-id="element-36" data-mp="335ndrcza8syb">
              <ShoppingCartIcon className="h-6 w-6 shrink-0" strokeWidth={2.5} aria-hidden="true" data-id="element-37" data-mp="2kctc1kqo6xc1" />
              <span className="flex flex-col text-left leading-tight" data-id="element-38" data-mp="26djw8m6dm58l">
                <span className="text-base font-black uppercase tracking-tight sm:text-lg" data-id="element-39" data-mp="26fd60acad5kt">Get it now for $27</span>
                <span className="text-xs font-semibold text-navy-900/80" data-id="element-40" data-mp="4lxap05972ji">One-time payment · Instant access</span>
              </span>
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}